import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import $ from "jquery";
import { useEffect, useRef } from "react";

const TablasClientes = ({ datos, columnas, id = "" }) => {
  const tableRef = useRef();

  useEffect(() => {
    const table = $(tableRef.current).DataTable({
      data: datos,
      columns: columnas,
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: true,
      responsive: true,
      dom:
        "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      language: {
        decimal: "",
        emptyTable: "No hay información",
        info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
        infoEmpty: "Mostrando 0 a 0 de 0 Entradas",
        infoFiltered: "(Filtrado de _MAX_ total entradas)",
        lengthMenu: "Mostrar _MENU_ Entradas",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "Sin resultados encontrados",
        paginate: {
          first: "|<<",
          last: ">>|",
          next: ">>",
          previous: "<<",
        },
      },
      destroy: true,
    });

    return () => {
      table.destroy();
    };
  }, [datos, columnas]);

  return (
    <div className="table-responsive">
      <table
        ref={tableRef}
        className="table table-bordered table-hover"
      ></table>
    </div>
  );
};

export default TablasClientes;
